import { Link, Typography } from "@mui/material";
import { EXTERNAL_LINKS } from "../../Config/constants";

const Copyright = () => {
  return (
    <Typography variant="body2" color="white">
      {"Copyright © "}
      <Link color="inherit" href={EXTERNAL_LINKS.UNIVERSITY}>
        Universidad de Cartagena
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
};

export default Copyright;
